const TOKEN_KEY = "cs_coach_token";

export class ApiError extends Error {
  constructor(message: string, public status: number) {
    super(message);
    this.name = "ApiError";
  }
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string | null): void {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  const token = getToken();
  if (token) headers.set("Authorization", `Bearer ${token}`);
  if (options.body && !(options.body instanceof FormData)) headers.set("Content-Type", "application/json");
  const response = await fetch(path, { ...options, headers });
  const body = await response.json().catch(() => ({})) as { message?: string };
  if (!response.ok) {
    if (response.status === 401) setToken(null);
    throw new ApiError(body.message || `请求失败 (${response.status})`, response.status);
  }
  return body as T;
}

export async function apiBlob(path: string): Promise<Blob> {
  const headers = new Headers();
  const token = getToken();
  if (token) headers.set("Authorization", `Bearer ${token}`);
  const response = await fetch(path, { headers });
  if (!response.ok) {
    if (response.status === 401) setToken(null);
    const body = await response.json().catch(() => ({})) as { message?: string };
    throw new Error(body.message || `文件读取失败 (${response.status})`);
  }
  return response.blob();
}

export function formatDate(value?: string | null): string {
  if (!value) return "-";
  return new Intl.DateTimeFormat("zh-CN", { month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" }).format(new Date(value));
}

export function formatSourcePages(start?: number | null, end?: number | null): string {
  if (!start) return "来源文档";
  return end && end > start ? `第 ${start}–${end} 页` : `第 ${start} 页`;
}

export function scoreTone(score?: number | null): string {
  if (score === null || score === undefined) return "neutral";
  if (score >= 80) return "good";
  if (score >= 60) return "warn";
  return "bad";
}
